import React from "react";
import classNames from "classnames";
import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export default function CharlieGunyon({...props}) {
    const { classes, className, style } = props;
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgRoundedCircle,
      classes.imgFluid
    );

  const data = useStaticQuery(
    graphql`
      query {
        image: file(relativePath: { eq: "charlie-gunyon.jpg" }) {
          childImageSharp {
           gatsbyImageData(
             width: 200
             placeholder: BLURRED
             formats: [AUTO, WEBP, AVIF]
           )
          }
        }
      }
    `
  );

 const image = getImage(data.image)

    return (
      <GatsbyImage
        image={image}
        alt="Portrait of Charlie Gunyon"
        className={classNames(imageClasses, className)}
        style={style}/>
    )
}
